export default __webpack_public_path__ + "static/media/Despacho nº 001-2023-Ouvidoria_20230828_0001.0caefccc.pdf";